import React from 'react';
import * as S from './checkout-form-skeleton.molecule.style';

export const CheckoutFormSkeleton: React.FC = () => {
  return (
    <S.FormContainer>

      <S.OfferCardSkeleton />
      {/* Título */}
      <S.TitleSkeleton />

      <S.FormFields>
        {/* Nome */}
        <S.FieldSkeleton>
          <S.LabelSkeleton />
          <S.InputSkeleton />
        </S.FieldSkeleton>

        {/* Email */}
        <S.FieldSkeleton>
          <S.LabelSkeleton />
          <S.InputSkeleton />
        </S.FieldSkeleton>

        {/* Telefone */}
        <S.GridContainer>
          <S.FieldSkeleton>
            <S.LabelSkeleton />
            <S.PhoneSkeleton>
              <S.CountrySkeleton />
              <S.PhoneInputSkeleton />
            </S.PhoneSkeleton>
          </S.FieldSkeleton>
        </S.GridContainer>

        {/* Info link */}
        <S.InfoLinkSkeleton />
      </S.FormFields>
    </S.FormContainer>
  );
};
